import { getBaseUrl, getWebBaseUrl } from '../config/appSettings';

/** Read by the API's logging middleware: every log line shows which portal page made the call. */
export const PAGE_URL_HEADER = 'X-Page-Url';

const trimSlash = (url) => String(url || '').replace(/\/+$/, '').toLowerCase();

const isOwnApiUrl = (url) => {
  const target = String(url || '').toLowerCase();
  if (!target) return false;
  return [getBaseUrl(), getWebBaseUrl()]
    .map(trimSlash)
    .some((base) => base && target.startsWith(base));
};

/**
 * Wraps window.fetch once so every request to our own API carries the current page path
 * (pathname only — query strings are not sent to logs). Third-party URLs are left untouched
 * so their CORS preflights are unaffected.
 */
export function installPageUrlHeader() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function' || window.__pageUrlHeaderInstalled) {
    return;
  }
  window.__pageUrlHeaderInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    try {
      const url = typeof input === 'string' ? input : input?.url;
      if (isOwnApiUrl(url)) {
        const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
        headers.set(PAGE_URL_HEADER, window.location.pathname || '/');
        return originalFetch(input, { ...(init || {}), headers });
      }
    } catch {
      // never block a request because of logging metadata
    }
    return originalFetch(input, init);
  };
}
